import { createNode, DurationDataType } from '@glueapp/graph-types';
import { formatDurationPattern } from '../../utils/formatTemporal';

export const FormatDurationPattern = createNode({
    id: 'Format Duration',
    name: 'Format Duration',
    description: 'Formats a duration using a custom pattern (e.g. H:mm:ss)',
    aiDescription:
        'Takes a Duration on the "Duration" port and formats it as a string on the "Text" port using a custom pattern configured in node state.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Duration: DurationDataType,
    },
    outPorts: {
        Text: { kind: 'string' },
    },
    interfaceComponentId: 'duration-format-editor',
    execute: function (input) {
        const pattern = (input.state.formatPattern as string) || "Y'years' M'months' D'd' H:mm:ss";
        const formatted = formatDurationPattern(input.inPorts.Duration, pattern);
        return { output: { Text: formatted } };
    },
});
